const OtherShippingOptionConstants = {
  additionalHandling: 'additional-handling',
  alcohol: 'alcohol',
  b13ACanada: 'b13a-canada',
  billToSender: 'bill-to-sender',
  billToThirdParty: 'bill-to-third-party',
  collectOnDelivery: 'collect-on-delivery',
  consequentialLoss: 'consequential-loss',
  dangerousGoods: 'dangerous-goods',
  dangerousGoodsLegacy: 'dangerous-goods-legacy',
  dangerousGoodsSimple: 'dangerous-goods-simple',
  dangerousGoodsDhlEcommerce: 'dangerous-goods-dhl-ecommerce',
  dangerousGoodsPurolator: 'dangerous-goods-purolator',
  deliveryMessage: 'delivery-message',
  doNotNotifyMarketplace: 'do-not-notify-marketplace',
  dontPrepayPostage: 'dont-prepay-postage',
  dryIce: 'dry-ice',
  emailNotification: 'email-notification',
  freightClass: 'freight-class',
  holdForPickup: 'hold-for-pickup',
  includeReturnLabel: 'include-return-label',
  localCollect: 'local-collect',
  nonMachinable: 'non-machinable',
  safeplace: 'safeplace',
  saturdayDelivery: 'saturday-delivery',
  saturdayGuarantee: 'saturday-guarantee',
  shipperRelease: 'shipper-release',
  smsNotification: 'sms-notification',
  specialHandling: 'special-handling',
  thirdPartyConsignee: 'third-party-consignee',
  carrierInsurance: 'carrier-insurance',
  ancillaryEndorsement: 'ancillary-endorsement-option',
  blockAmazonLogistics: 'block_amazon_logistics',
  useBlankBox: 'blank_box',
  goGreenPlus: 'gogreen-plus',
  regulatedContentType: 'regulated-content-type',
  movementIndicator: 'windsor-framework-movement-indicator',
  notAtRisk: 'windsor-framework-not-at-risk',
  fedExShipperLoadAndCount: 'shipper-load-and-count',
  fedExBookingConfirmation: 'booking-confirmation',
  exportLicenceRequired: 'export-licence-required',
  serviceLevel: 'service-level',
  fragile: 'fragile',
  deliveryAsAddressed: 'delivery-as-addressed',
  returnAfterFirstAttempt: 'return-after-first-attempt',
  certificateOfOrigin: 'certificate-of-origin',
};

export default OtherShippingOptionConstants;
